import { onError } from '@apollo/client/link/error/index.js';
export const createErrorLink = (graphBasePath, { errorPageUrl = `${graphBasePath}/error`, appendSupportParams = true } = {}) => {
    return onError(({ graphQLErrors, operation }) => {
        if (graphQLErrors) {
            if (typeof window !== 'undefined') {
                let redirectUrl = errorPageUrl;
                if (appendSupportParams) {
                    const httpLogPageLoadId = operation.getContext().headers.HttpLogPageLoadId;
                    const httpLogRequestId = operation.getContext().headers.HttpLogRequestId;
                    const params = new URLSearchParams({
                        httpLogRequestId,
                        httpLogPageLoadId,
                        date: new Date().toUTCString()
                    });
                    redirectUrl += `?${params.toString()}`;
                }
                window.location.href = redirectUrl;
            }
        }
    });
};
//# sourceMappingURL=createErrorLink.js.map